import React, { useContext } from 'react';
import { DatePicker } from 'antd';
import { SelectValue } from 'antd/lib/select';
import { RangePickerValue } from 'antd/lib/date-picker/interface';
import { isString } from 'src/utils/typeGuards';
import { convertMomentToString, convertStringToMoment } from 'src/utils/dateUtils';
import Select from 'src/components/common/Select';
import UserContext from 'src/services/UserContext';
import { Filters, FiltersContext } from '../FiltersProvider';
import useFiltersListFetch from '../hooks/useFiltersListFetch';
import styles from './FiltersList.module.less';

const { RangePicker } = DatePicker;
const { Option } = Select;

type FiltersListProps = {
  appId: string;
  siteCode: string;
  scriptName: string;
};

export const FiltersList: React.FC<FiltersListProps> = ({ appId, siteCode, scriptName }) => {
  const { filters, setFilter } = useContext(FiltersContext);
  const { applications, errorsCodes, statuses } = useFiltersListFetch(appId, siteCode, scriptName);

  const updateFilter = (key: keyof Filters) => (value: SelectValue) => {
    if (isString(value)) {
      setFilter(key, value);
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.filter}>
        <RangePicker
          value={[convertStringToMoment(filters.startDate), convertStringToMoment(filters.endDate)] as RangePickerValue}
          onChange={([startDate, endDate]) => {
            setFilter('startDate', convertMomentToString(startDate));
            setFilter('endDate', convertMomentToString(endDate));
          }}
          size="large"
          placeholder={['From', 'Through']}
          format={UserContext.getDateFormat()}
        />
      </div>

      <div className={styles.filter}>
        <Select
          value={filters.application ?? undefined}
          onChange={updateFilter('application')}
          placeholder="Application"
          size="large"
          allowClear
          showSearch
        >
          {applications.map((item) => (
            <Option value={item.appId} key={item.appId}>
              {item.appName}
            </Option>
          ))}
        </Select>
      </div>

      <div className={styles.filter}>
        <Select
          value={filters.errorCode ?? undefined}
          onChange={updateFilter('errorCode')}
          placeholder="Error Code"
          size="large"
          allowClear
          showSearch
        >
          {errorsCodes.map((item) => (
            <Option value={item} key={item}>
              {item}
            </Option>
          ))}
        </Select>
      </div>

      <div className={styles.filter}>
        <Select
          value={filters.scriptStatus ?? undefined}
          onChange={updateFilter('scriptStatus')}
          placeholder="Script Status"
          size="large"
          allowClear
        >
          {statuses.map((item) => (
            <Option value={item} key={item}>
              {item}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  );
};
